import { render } from "./SubscriptionInviteCognitoLandingView.vue?vue&type=template&id=71f35f93&ts=true"
import script from "./SubscriptionInviteCognitoLandingView.vue?vue&type=script&lang=ts"
export * from "./SubscriptionInviteCognitoLandingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__